<template>
  <div class="ticactoe" style="width: 100%;">

    <div v-if="!connected" style="text-align: center;margin-top: 20px;">
      <el-text class="mx-1" style="color: white;font-size: 30px;">程序尝试重连中...</el-text>
      <el-text class="mx-1" style="color: white;font-size: 30px;">
        终极解决：若3秒没有反应，请关闭本页面和程序，重新打开🐷程序
      </el-text>
      <br/>
      <!--      <button class="custom-btn btn-9" @click="handleLogin"><span>启 动</span></button>-->
    </div>

    <!--    <div v-if="connected && !isLoin" style="text-align: center;margin-top: 20px;">-->
    <!--      <el-text class="mx-1" style="color: white;font-size: 30px;">程序启动成功，点击启动微信...~</el-text><br/>-->

    <!--      <button class="custom-btn btn-9" @click="handleLogin"><span>启 动 微 信</span></button>-->
    <!--    </div>-->

    <div v-if="connected && !isAuth" style="text-align: center;margin-top: 20px;">
      <el-form class="center-button">
        <el-form-item>
          <el-text class="mx-1" style="color: white;font-size: 20px;">请输入密钥</el-text>
          <br/>
        </el-form-item>
        <el-form-item>
          <el-input class="dynamic-width-input" v-model="secret" placeholder="请输入密钥"
                    clearable style="width: 600px;"/>
        </el-form-item>
        <el-form-item>
          <el-text class="mx-1" style="color: white;font-size: 20px;">输入邀请码(可选)</el-text>
          <br/>
        </el-form-item>
        <el-form-item>
          <el-input class="dynamic-width-input" v-model="inviteCode" placeholder="邀请码(可选)"
                    clearable/>
        </el-form-item>
        <el-form-item>

          <el-text class="mx-1" style="color: white;font-size: 20px;">如有疑问，请联系技术支持</el-text>
        </el-form-item>
        <el-form-item>
          <button class="custom-btn btn-9 center-button" @click="handleActive"><span>激 活</span></button>
        </el-form-item>
      </el-form>
    </div>


    <div class="user_skills" v-if="connected && isAuth" style="margin-top:20px;position: relative;">
      <!-- 帮助按钮绝对定位到右上角 -->
      <!--      <el-tooltip v-if="showTooltip" content="使用帮助" placement="top" :target="helpButtonRef">-->
      <!--        <span ref="helpButtonRef" class="help-button" style="cursor: pointer; position: absolute; top: 0; right: 0;">📕</span>-->
      <!--      </el-tooltip>-->
      <el-table :data="filterTableData" style="width: 100%;color: white;"
                :header-cell-style="{background:'#eef1f6',color:'#606266'}">
        <el-table-column label="序号" prop="order" width="80"/>
        <el-table-column label="群头像" prop="avatar_url" width="100">
          <template #default="scope">
            <div style="height: 45px;width: 45px">
              <el-image :src="scope.row.avatar_url ? peerUrl + '/v1/proxy?url=' + scope.row.avatar_url : ''"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="群聊昵称" prop="roomName" width="200"/>
        <el-table-column label="群ID" prop="roomId" width="200"/>
        <el-table-column label="总开关" align="center" width="150">
          <template #default="scope">
            <div class="icon-container">
              <el-icon :size="20" v-if="scope.row.ruleTask?.switchValue">
                🚀
              </el-icon>
              <el-icon :size="20" v-if="scope.row.timerTask?.switchValue">
                ⏰
              </el-icon>
              <el-icon :size="20" v-if="scope.row.followTask?.switchValue">
                🏃‍♂️
              </el-icon>
              <el-icon :size="20" v-if="scope.row.KeyTask?.switchValue">
                📌️
              </el-icon>
              <el-icon :size="20" v-if="scope.row.AiTask?.switchValue">
                🎯
              </el-icon>
              <el-switch style="margin: 0 10px;" v-model="scope.row.isOpen" active-color="#9900ff"
                         @change="handleSwitchChange(scope.row, $event)"/>
              <!--							<el-button color="#626aef" size="large" @click="handleEdit(scope.$index, scope.row)">设置</el-button>-->
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #header>
            <el-input v-model="search" @input="searchChange" clearable size="" placeholder="搜索群昵称"/>
          </template>
          <template #default="scope">
            <div class="icon-container">
              <button class="custom-btn btn-9" @click="handleEdit(scope.$index, scope.row)"><span>设置</span></button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加分页器 -->
      <el-pagination v-if="allRoomSettings.length > pageSize" :background="true" layout="prev, pager, next"
                     :page-count="pageCount" @current-change="changePage"/>
      <!--      <div style="margin-top: 10px;">-->
      <!--        <button class="custom-btn btn-9" @click="handleAdd(scope.$index, scope.row)"><span>手动添加</span></button>-->
      <!--      </div>-->
      <!--      <button class="custom-btn btn-9" @click="handleEdit(scope.$index, scope.row)"><span>手动添加</span></button>-->
    </div>


    <el-dialog class="dialog-content" v-model="dialogFormVisible" title="选项配置" width="80%"
               style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
      <el-form ref="form" :model="itemSettings" label-width="80px">
        <el-form-item :label="'🚀 ' + itemSettings.ruleTask.title" :label-width="formLabelWidth">
          <el-text class="mx-1" style="margin: 0 20px;">开关</el-text>
          <el-switch v-model="itemSettings.ruleTask.switchValue"/>
          <!--          <el-icon :size="20" style="margin-left: 20px">-->
          <!--            🚀-->
          <!--          </el-icon>-->
        </el-form-item>

        <transition name="fade" mode="out-in">
          <div v-if="itemSettings.ruleTask.switchValue">

            <el-card>
              <el-table :data="itemSettings.ruleTask.rules" style="width: 100%">
                <el-table-column prop="detectText" label="识别内容"/>
                <el-table-column prop="deal_names" label="发送规则"/>
                <el-table-column label="目标机器人">
                  <template v-slot="scope">
                  <span>
                    {{ formatSenders(scope.row.senders) }}
                  </span>
                  </template>
                </el-table-column>
                <el-table-column label="屏蔽人">
                  <template v-slot="scope">
                  <span>
                    {{ formatSenders(scope.row.ban_senders) }}
                  </span>
                  </template>
                </el-table-column>
                <el-table-column prop="keyContent" label="触发文本"/>
                <el-table-column prop="timeoutTime" label="延迟(ms)"/>
                <el-table-column label="操作" width="150">
                  <template v-slot="scope">
                    <div style="display: flex; align-items: center; gap: 2px;">
                      <el-button size="small" type="primary" @click="editRule(scope.row, scope.$index)">编辑</el-button>
                      <el-button size="small" type="danger" @click="removeRule(scope.$index)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="primary" class="mt-4" @click="openDialog" style="margin-top: 10px;">增加</el-button>
            </el-card>
            <!--            <el-form-item label="粘贴需要识别的文本内容" :label-width="formLabelWidth">-->
            <!--              <el-input class="dynamic-width-input" type="textarea" :rows="3" v-model="itemSettings.ruleTask.detectText"-->
            <!--                        placeholder="请输入需要被识别的文本" clearable/>-->
            <!--              <el-button style="margin-left: 10px;" type="primary" @click="aiDetectFun">智能识别</el-button>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="设定发送规则(选)" :label-width="formLabelWidth">-->
            <!--              <el-select-->
            <!--                  v-model="itemSettings.ruleTask.deal_names"-->
            <!--                  class="m-2"-->
            <!--                  placeholder="勾选规则"-->
            <!--                  style="min-width: 200px; width: auto;"-->
            <!--                  ref="ruleSelect"-->
            <!--                  @change="handleRulesChange"-->
            <!--                  multiple-->
            <!--              >-->
            <!--                <el-option-->
            <!--                    v-for="item in rules"-->
            <!--                    :key="item.key + item.value"-->
            <!--                    :label="item.key + '=>' + item.value"-->
            <!--                    :value="item.key"-->
            <!--                    @mouseenter="handleMouseEnter(item.key)"-->
            <!--                    @mouseleave="handleMouseLeave(item.key)"-->
            <!--                />-->
            <!--              </el-select>-->
            <!--              <div v-if="getGifSource(hoveredOption)" class="gif-container">-->
            <!--                <img :src="getGifSource(hoveredOption)" alt="GIF" class="gif-image"/>-->
            <!--              </div>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="目标机器人" :label-width="formLabelWidth">-->
            <!--              <el-select-->
            <!--                  v-model="itemSettings.ruleTask.senders"-->
            <!--                  class="m-2"-->
            <!--                  filterable-->
            <!--                  placeholder="检测指定微信消息"-->
            <!--                  multiple-->
            <!--                  style="width: 200px"-->
            <!--              >-->
            <!--                <el-option-->
            <!--                    v-for="item in room_members"-->
            <!--                    :key="item.key"-->
            <!--                    :label="item.value"-->
            <!--                    :value="item.key"-->
            <!--                />-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="触发扣排文本" :label-width="formLabelWidth">-->
            <!--              <el-input class="dynamic-width-input" v-model="itemSettings.ruleTask.keyContent"-->
            <!--                        placeholder="请输入触发扣排的文本内容" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="延迟发送时间(ms)" :label-width="formLabelWidth">-->
            <!--              <el-select-->
            <!--                  v-model="itemSettings.ruleTask.timeoutTime"-->
            <!--                  class="m-2"-->
            <!--                  placeholder="Select"-->
            <!--                  style="width: 100px"-->
            <!--              >-->
            <!--                <el-option-->
            <!--                    v-for="item in timeoutPickers"-->
            <!--                    :key="item"-->
            <!--                    :label="item"-->
            <!--                    :value="item"-->
            <!--                />-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->


            <el-form-item label="识别几次后关闭" :label-width="formLabelWidth" style="margin-top: 10px;">
              <el-select
                  v-model="itemSettings.ruleTask.closeTimer"
                  class="m-2"
                  placeholder="次数"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timerClosePickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
          </div>
        </transition>


        <!--				Task2 TimerSend-->
        <el-form-item :label="'⏰ ' + itemSettings.timerTask.title" :label-width="formLabelWidth">
          <el-text class="mx-1" style="margin: 0 20px;">开关</el-text>
          <el-switch v-model="itemSettings.timerTask.switchValue"/>
          <!--					<el-icon :size="20" style="margin-left: 20px">-->
          <!--						⏰-->
          <!--					</el-icon>-->
        </el-form-item>
        <transition name="fade" mode="out-in">
          <div v-if="itemSettings.timerTask.switchValue">
            <el-form-item label="设定发送时间(分)" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.timerTask.minutesValue"
                  class="m-2"
                  placeholder="Select"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in minutesNumPickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="定时发送输入内容" :label-width="formLabelWidth">
              <el-input class="dynamic-width-input" v-model="itemSettings.timerTask.sendContent"
                        placeholder="请输入定时发送的文本内容" clearable/>
            </el-form-item>
            <el-form-item label="延迟发送时间(ms)" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.timerTask.timeoutTime"
                  class="m-2"
                  placeholder="Select"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timeoutPickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
          </div>
        </transition>


        <!--				Task3 FollowTask-->
        <el-form-item :label="'🏃‍♂️ ' + itemSettings.followTask.title" :label-width="formLabelWidth">
          <el-text class="mx-1" style="margin: 0 20px;">开关</el-text>
          <el-switch v-model="itemSettings.followTask.switchValue"/>
          <!--					<el-icon :size="20" style="margin-left: 20px">-->
          <!--						🏃‍♂️-->
          <!--					</el-icon>-->
        </el-form-item>

        <transition name="fade" mode="out-in">
          <div v-if="itemSettings.followTask.switchValue">
            <el-form-item label="触发次数选择(次)" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.followTask.sendTimer"
                  class="m-2"
                  placeholder="Select"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timerPickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="粘贴需要关键字识别文案" :label-width="formLabelWidth">
              <el-input class="dynamic-width-input" type="textarea" :rows="3"
                        v-model="itemSettings.followTask.startText"
                        placeholder="关键字文案" clearable/>
            </el-form-item>
            <el-form-item label="识别几次后关闭" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.followTask.closeTimer"
                  class="m-2"
                  placeholder="次数"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timerClosePickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="延迟发送时间(ms)" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.followTask.timeoutTime"
                  class="m-2"
                  placeholder="Select"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timeoutPickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
          </div>
        </transition>


        <!--				Task4 KeyTask-->
        <el-form-item :label="'📌️ ' + itemSettings.KeyTask.title" :label-width="formLabelWidth">
          <el-text class="mx-1" style="margin: 0 20px;">开关</el-text>
          <el-switch v-model="itemSettings.KeyTask.switchValue"/>
        </el-form-item>

        <transition name="fade" mode="out-in">
          <div v-if="itemSettings.KeyTask.switchValue">
            <el-form-item label="识别的关键字" :label-width="formLabelWidth">
              <el-input class="dynamic-width-input" type="textarea" :rows="3" v-model="itemSettings.KeyTask.keyText"
                        placeholder="关键字文案" clearable/>
            </el-form-item>
            <el-form-item label="指定发送人" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.KeyTask.senders"
                  class="m-2"
                  filterable
                  placeholder="检测指定微信消息"
                  multiple
                  style="width: 200px"
              >
                <el-option
                    v-for="item in raw_members.slice(1)"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="触发后发送内容" :label-width="formLabelWidth">
              <el-input class="dynamic-width-input" v-model="itemSettings.KeyTask.sendContent"
                        placeholder="请输入触发关键字发送的文本内容" clearable/>
            </el-form-item>
            <el-form-item label="识别几次后关闭" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.KeyTask.closeTimer"
                  class="m-2"
                  placeholder="次数"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timerClosePickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="延迟发送时间(ms)" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.KeyTask.timeoutTime"
                  class="m-2"
                  placeholder="Select"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timeoutPickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
          </div>
        </transition>

        <!--				Task5 AiTask-->
        <el-form-item :label="'🎯 ' + itemSettings.AiTask.title" :label-width="formLabelWidth">
          <el-text class="mx-1" style="margin: 0 20px;">开关</el-text>
          <el-tooltip content="只有Pro以上会员才可以开启此功能哦！" placement="top">
            <el-switch v-model="itemSettings.AiTask.switchValue" :disabled="codeLevel < 9"/>
          </el-tooltip>

        </el-form-item>

        <transition name="fade" mode="out-in">
          <div v-if="itemSettings.AiTask.switchValue">
            <el-form-item label="触发的关键字" :label-width="formLabelWidth">
              <el-input class="dynamic-width-input" type="textarea" :rows="3" v-model="itemSettings.AiTask.keyText"
                        placeholder="关键字" clearable/>
            </el-form-item>
            <el-form-item label="目标机器人" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.AiTask.senders"
                  class="m-2"
                  filterable
                  placeholder="检测指定微信消息"
                  multiple
                  style="width: 200px"
              >
                <el-option
                    v-for="item in raw_members.slice(1)"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="识别几次后关闭" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.AiTask.closeTimer"
                  class="m-2"
                  placeholder="次数"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timerClosePickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="延迟发送时间(ms)" :label-width="formLabelWidth">
              <el-select
                  v-model="itemSettings.AiTask.timeoutTime"
                  class="m-2"
                  placeholder="Select"
                  style="width: 100px"
              >
                <el-option
                    v-for="item in timeoutPickers"
                    :key="item"
                    :label="item"
                    :value="item"
                />
              </el-select>
            </el-form-item>
          </div>
        </transition>

      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="SaveFormData(itemSettings)">
          保存
        </el-button>
      </span>
      </template>
    </el-dialog>

    <el-dialog class="dialog-content" v-model="isShowSubmitRules" title="规则提交"
               style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
      <el-form class=" center-button">
        <el-form-item>
          <el-text class="mx-1" style="color: white;font-size: 20px;">请将扣排规则复制给卖家~</el-text>
          <br/>
        </el-form-item>

        <el-form-item>
          <el-text class="mx-1" style="color: white;font-size: 20px;">预计1-2天完成兼容~</el-text>
        </el-form-item>
        <el-form-item>
          <div class="icon-container">
            <button class="custom-btn btn-9 center-button" @click="isShowSubmitRules = false"><span>关 闭</span>
            </button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>


    <el-dialog
        v-model="dialogVisible" style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);"
        title="添加识别规则"
        width="600px"
        @close="handleClose"
    >
      <el-form :model="currentRule" label-position="top">
        <el-form-item label="粘贴需要识别的文本内容">
          <el-input
              type="textarea"
              v-model="currentRule.detectText"
              :rows="3"
              placeholder="请输入需要被识别的文本"
              clearable
          />
          <el-button style="margin-left: 10px;margin-top: 10px;" type="primary" @click="aiDetectFun">智能识别
          </el-button>
        </el-form-item>

        <el-form-item label="设定发送规则(选)">
          <el-select
              v-model="currentRule.deal_names"
              placeholder="勾选规则"
              ref="ruleSelect"
              style="min-width: 200px;"
          >
            <el-option
                v-for="item in rules"
                :key="item.key"
                :label="item.key + '=>' + item.value"
                :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="目标机器人">
          <el-select
              v-model="currentRule.senders"
              filterable
              placeholder="检测指定微信消息"
              multiple
              style="width: 200px"
          >
            <el-option
                v-for="item in room_members"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="触发扣排文本">
          <el-input
              v-model="currentRule.keyContent"
              placeholder="请输入触发扣排的文本内容"
              clearable
          />
        </el-form-item>
        <el-form-item label="屏蔽人">
          <el-select
              v-model="currentRule.ban_senders"
              filterable
              placeholder="屏蔽指定人消息"
              multiple
              style="width: 200px"
          >
            <el-option
                v-for="item in room_members"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="消息缓存数">
          <el-select
              v-model="currentRule.msg_num"
              placeholder="消息缓存"
              style="width: 100px"
          >
            <el-option
                v-for="item in timerPickers"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="延迟发送时间(ms)">
          <el-select
              v-model="currentRule.timeoutTime"
              placeholder="延迟发送"
              style="width: 100px"
          >
            <el-option
                v-for="item in timeoutPickers"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveRule">确认</el-button>
    </span>
    </el-dialog>
  </div>

</template>

<script>
// 禁用整个文件的 ESLint 检查
/* eslint-disable */
// const { postRemoteData } = require('@/api/reqWx.js');
import axios from "axios";
import {ElMessage} from "element-plus";
// 引入 socket.io-client
import io from 'socket.io-client';
import {handleEncryptData, handleDecryptData} from '@/libs/tools.js';
import {isDebug} from '@/config/config.js';
import RuleSettingDialog from "./RuleSettingDialog.vue";

export default {
  components: {
    RuleSettingDialog,
  },
  name: "TictactoeView",
  // 1.根据规则发 2.根据时间发 3.多少条触发发 4.监控开始结束时间
  data() {
    return {
      dialogVisible: false,
      currentIndex: -1,  // -1 表示是新增
      currentRule: {
        detectText: "",
        deal_names: [],
        senders: [],
        ban_senders: [],
        msg_num: 1,
        keyContent: "",
        timeoutTime: null,
      },
      minutesPickers: ["不限"].concat(Array.from(Array(60).keys())),
      minutesNumPickers: Array.from(Array(60).keys()),
      timeoutPickers: Array.from({length: (5000 / 500) + 1}, (_, index) => index * 500),
      timerPickers: Array.from(Array(10).keys()).map(num => num + 1),
      timerClosePickers: ["一直扣"].concat(Array.from(Array(100).keys()).map(num => num + 1)),
      allRoomSettings: [],
      showAllRoomSettings: [],
      raw_members: [],
      room_members: [{
        "key": "wxid_1",
        "value": "微信1"
      }],
      search: "",
      submitText: '',       // 用户输入的文本
      fileList: [],         // 存储选择的文件
      uploadedFile: null,   // 存储上传的文件
      isShowSubmitRules: false,
      roomListSelects: [],
      itemSettings: {
        "ruleTask": {
          "title": "功能一",
          "switchValue": false,
          "rules": [],
          "timeoutTime": 0,
        },
        "timerTask": {
          "title": "功能二",
          "switchValue": false,
          "minutesValue": 0,
          "sendContent": "",
          "timeoutTime": 0
        },
        "followTask": {
          "title": "功能三",
          "switchValue": false,
          "startText": "",
          "closeTimer": "一直扣",
          "sendTimer": 3,
          "timeoutTime": 0
        },
        "KeyTask": {
          "title": "功能四",
          "switchValue": false,
          "keyText": "",
          "senders": [],
          "closeTimer": "一直扣",
          "sendContent": "p",
          "timeoutTime": 0
        },
        "AiTask": {
          "title": "功能五",
          "switchValue": false,
          "keyText": "",
          "senders": "",
          "closeTimer": "一直扣",
          "timeoutTime": 0
        }
      },
      dialogFormVisible: false,
      formLabelWidth: "130px",
      totalPageCount: 15,
      totalCount: 15,
      isAllData: [
        {
          "order": "1",
          "roomName": "xxxRoom",
          "roomId": "abc@chatroom",
          "memberNum": 10,
          "selfName": "xx",
          "isOpen": false
        },
        {
          "order": "1",
          "roomName": "xxxRoom",
          "roomId": "abc@chatroom",
          "memberNum": 10,
          "selfName": "xx",
          "isOpen": false
        },
        {
          "order": "1",
          "roomName": "xxxRoom",
          "roomId": "abc@chatroom",
          "memberNum": 10,
          "selfName": "xx",
          "isOpen": false
        },
        {
          "order": "1",
          "roomName": "xxxRoom",
          "roomId": "abc@chatroom",
          "memberNum": 10,
          "selfName": "xx",
          "isOpen": false
        }
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      baseWsUrl: "ws://127.0.0.1:3001",
      baseUrl: "http://127.0.0.1:3001",
      peerUrl: "https://api.8188811.xyz",
      websocket: null,
      connected: false,
      isLoin: false,
      currentLoginWx: null,
      fullLoginWxs: null,
      fullRoomList: null,
      isAuth: false,
      codeLevel: 0,
      showTooltip: false,
      secret: "",
      inviteCode: "",
      rules: [{
        "key": "请填入需要识别的规则，点'智能识别'",
        "value": "请填入需要识别的规则，点'智能识别'"
      }],
      response: '',
      socket: null,
      maxReconnectAttempts: 999,
      reconnectAttempts: 0,
      timercheck: 1,

      help_imgs: {
        "识别图片12_26": "http://pic.8188811.xyz/i/2024/12/28/iponhb.png"
      },

      pingInterval: null,  // 保存ping定时器
      hoveredOption: null, // 当前悬停的选项
      hoverTimer: null, // 用于保存定时器引用
    }
  },
  async mounted() {
    // 页面加载时连接 WebSocket
    this.socket = io('http://localhost:5000', {
      reconnectionAttempts: this.maxReconnectAttempts, // 最大重连尝试次数
      reconnectionDelay: 5000, // 每次重连的间隔时间
      reconnectionDelayMax: 0, // 重连的最大延迟
      autoConnect: true, // 自动连接（不需要手动调用 this.socket.connect()）
    });


    this.socket.on('connect', () => {
      ////console.log('已连接到服务器');
      // 在连接成功后执行的操作
      // this.socket.emit('message', 'Hello, server!');
      this.reconnectAttempts = 0; // 重置重连次数
      this.sendMessage({"data_type": "get_login_wx"})
      ////console.log("重连成功")
      this.$store.commit('setWebsocket', this.socket);
    });

    this.socket.on('connect_error', (error) => {
      ////console.log('Connection failed:', error);
      this.reconnectAttempts++;
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        ////console.log('Max reconnect attempts reached. Closing the window.');
      }
    });

    // 监听服务器响应
    this.socket.on('response', (data) => {
      data = handleDecryptData(data, isDebug)
      this.response = data.data;
      ////console.log(data)
      ////console.log(data["data_type"])
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty("data_type")) {
        if (data["data_type"] === "get_login_wx") {
          this.check_backend(data.data)
        }
        if (data["data_type"] === "load_room_list") {
          ////console.log("收到群聊加载")
          this.handleLoadRoomList(data.data)
        }
        if (data["data_type"] === "action") {
          this.handleActiveLocal(data)
        }
        if (data["data_type"] === "room_members") {
          this.handleRoomMembers(data)
        }
        if (data["data_type"] === "settings") {
          if (data.code === 0) {
            ElMessage.success("保存成功~")
          } else {
            ElMessage.error(data.msg)
          }
        }
        if (data["data_type"] === "complete_ruleTask") {
          for (let i = 0; i < this.allRoomSettings.length; i++) {
            if (this.allRoomSettings[i]["roomId"] === data["roomId"]) {
              this.allRoomSettings[i]["ruleTask"]["switchValue"] = false
            }
          }
          this.showAllRoomSettings = this.allRoomSettings
        }
        if (data["data_type"] === "complete_followTask") {
          for (let i = 0; i < this.allRoomSettings.length; i++) {
            if (this.allRoomSettings[i]["roomId"] === data["roomId"]) {
              this.allRoomSettings[i]["followTask"]["switchValue"] = false
            }
          }
          this.showAllRoomSettings = this.allRoomSettings
        }
        if (data["data_type"] === "complete_keyTask") {
          for (let i = 0; i < this.allRoomSettings.length; i++) {
            if (this.allRoomSettings[i]["roomId"] === data["roomId"]) {
              this.allRoomSettings[i]["KeyTask"]["switchValue"] = false
            }
          }
          this.showAllRoomSettings = this.allRoomSettings
        }
        if (data["data_type"] === "complete_aiTask") {
          for (let i = 0; i < this.allRoomSettings.length; i++) {
            if (this.allRoomSettings[i]["roomId"] === data["roomId"]) {
              this.allRoomSettings[i]["AiTask"]["switchValue"] = false
            }
          }
          this.showAllRoomSettings = this.allRoomSettings
        }
      }
    });
    // 监听message
    this.socket.on('message', (data) => {
      data = handleDecryptData(data, isDebug)
      ////console.log("收到消息数据", data)
      this.sendGlobalMessage(data.title, data.content, data.time)
    });

    this.socket.on('disconnect', () => {
      ////console.log("页面断开")
      this.connected = false
      this.isLoin = false
      this.isAuth = false
      ////console.log("收到消息数据", data)
      this.sendGlobalMessage("连接中断", "请重试", "now")
    });

    setTimeout(() => {
      this.showTooltip = true;
    }, 3000)

  },
  beforeUnmount() {
    // 断开 WebSocket 连接并清除定时器
    if (this.socket) {
      this.socket.disconnect();
    }
    if (this.pingInterval) {
      clearInterval(this.pingInterval);  // 清除ping定时器
    }
  },
  // 3. 在 methods 中定义函数
  methods: {
    async check_backend(resData) {
      // let url = this.baseUrl + "/get_login_wx"
      // let resData = await this.postAxios(url, {})
      if (resData) {
        ////console.log("后台已正常启动...", resData)
        this.fullLoginWxs = resData
        this.connected = true
        this.isAuth = resData["is_auth"]
        this.codeLevel = resData["code_level"] ? resData.hasOwnProperty("code_level") && resData["code_level"] : 0
        ////console.log("当前等级" + this.codeLevel)
        this.$store.commit('setCodeLevel', this.codeLevel);
        this.isLoin = true
        if (this.isAuth) {
          ////console.log("进入加载群")
          ////console.log(this.fullLoginWxs)
          this.$store.commit('setSecret', resData["code"]);
          for (let wxid in this.fullLoginWxs) {
            if (wxid !== this.fullLoginWxs[wxid]["wxid"]) {
              ////console.log("跳过1")
              continue
            }
            ////console.log(this.fullLoginWxs[wxid])
            ////console.log(wxid)
            ////console.log(this.fullLoginWxs[wxid]["expire_time"])
            ////console.log("this.fullLoginWxs", this.fullLoginWxs[wxid]["expire_time"])
            // eslint-disable-next-line no-prototype-builtins
            if (this.fullLoginWxs[wxid].hasOwnProperty("expire_time")) {
              this.$store.commit("setExpireTime", this.fullLoginWxs[wxid]["expire_time"])
            }
            // eslint-disable-next-line no-prototype-builtins
            if (this.fullLoginWxs.hasOwnProperty(wxid)) {
              this.currentLoginWx = this.fullLoginWxs[wxid]
              this.$store.commit("setAvatarUrl", this.currentLoginWx["small_head_img_url"])
              await this.LoadRoomList()
              ////console.log("this.currentLoginWx", this.currentLoginWx)
              if (this.isLoin && this.isAuth) {
                setTimeout(() => {
                  this.postSettings()
                }, 3000)
              }

              this.$store.commit('setCurrentInfo', this.currentLoginWx);
              return true
            }
          }
        } else {
          ////console.log("授权失败")
        }
      } else {
        this.connected = false
        return false
      }
    },
    openDialog() {
      ////console.log(1)
      this.currentRule = {
        detectText: "",
        deal_names: [],
        senders: [],
        ban_senders: [],
        msg_num: 1,
        keyContent: "",
        timeoutTime: 0,
      };
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    formatSenders(res) {
      ////console.log(`格式化发送人: ${res}`)
      ////console.log(`rooms: ${this.room_members}`)
      let senderArr = []
      if(res) {
        res.forEach(item => {
          this.room_members.forEach(member => {
            ////console.log(`itemmember: ${JSON.stringify(member)}`)
            if(member["key"] === item) {
              senderArr.push(member["value"])
            }
          })
        })
      }
      ////console.log(`senderArr: ${senderArr}`)
      return senderArr.join(",")
    },
    saveRule() {
      if (this.currentIndex === -1) {
        // 新增
        if(!this.itemSettings.ruleTask.hasOwnProperty("rules")) {
          this.itemSettings.ruleTask.rules = []
        }
        this.itemSettings.ruleTask.rules.push(this.currentRule);
      } else {
        // 编辑：替换原来的项
        this.itemSettings.ruleTask.rules.splice(this.currentIndex, 1, this.currentRule);
      }
      // this.itemSettings.ruleTask["rules"] = this.ruleList
      // 重置状态
      this.currentRule = {};
      this.currentIndex = -1;
      this.dialogVisible = false;
    },
    editRule(row, index) {
      this.dialogVisible = true;
      this.currentRule = Object.assign({}, row);
      this.currentIndex = index;  // 记录正在编辑的下标
    },
    removeRule(index) {
      this.itemSettings.ruleTask["rules"].splice(index, 1);
    },
    async aiDetectFun() {
      let url = this.peerUrl + "/v1/kou_pai/detect2_0"
      let data = {
        "msg": this.currentRule.detectText
      }
      ////console.log("发送请求获取解析代码")
      ////console.log(data)
      let resData = await this.postAxios(url, data)
      ////console.log("===")
      ////console.log(resData)
      this.rules = []
      for (let i = 0; i < resData.data.length; i++) {
        if (typeof resData.data[i]["value"] === "string") {
          this.rules.push({
            key: resData.data[i]["key"],
            value: resData.data[i]["value"],
            raw_data: resData.data[i]["value"]
          })
        }
        if (typeof resData.data[i]["value"] === "object" && resData.data[i]["value"] !== null) {
          this.rules.push({
            key: resData.data[i]["key"],
            value: resData.data[i]["value"]["content"],
            raw_data: resData.data[i]["value"]
          })
          this.help_imgs[resData.data[i]["key"]] = resData.data[i]["value"]["help_img"]
        }
      }
      this.rules.push({
        key: "没有找到合适的?",
        value: "提交更多扣排方式"
      })
      ////console.log(this.rules)
      ////console.log(this.help_imgs)
      // this.itemSettings.ruleTask.deal_names = []
      this.$refs.ruleSelect.toggleMenu();
    },
    handleMouseEnter(key) {
      this.hoverTimer = setTimeout(() => {
        this.hoveredOption = key; // 悬停 0.5 秒后显示 GIF
      }, 300); // 500ms 后显示 GIF
    },
    handleMouseLeave(key) {
      clearTimeout(this.hoverTimer); // 悬停取消时清除定时器
      if (this.hoveredOption === key) {
        this.hoveredOption = null; // 移出时隐藏 GIF
      }
    },
    getGifSource(key) {
      // 根据 key 返回对应的 GIF 地址，这里用伪代码作为示例
      return this.help_imgs[key]
    },
    handleRulesChange(value) {
      ////console.log("rule change", value)
      if (value.includes('没有找到合适的?')) {
        // 处理值为 'xxx' 的情况
        this.isShowSubmitRules = true
      } else {
        // 处理其他选项
        ////console.log('选中了其他规则');
      }
      // 将获取的预设字段处理
    },
    // 选择文件时调用
    handleBeforeUpload(file) {
      // 选择文件后，保存文件对象
      this.uploadedFile = file;
      ////console.log('选择的文件:', file);

      // 这里只是为了防止自动上传，返回 false
      return false;
    },

    // 删除文件时的回调
    // eslint-disable-next-line no-unused-vars
    handleRemoveFile(file) {
      this.uploadedFile = null;
      ////console.log('删除的文件:', file);
    },

    handleFileChange(file, fileList) {
      // 当文件变化时，更新 fileList
      this.fileList = fileList;
      ////console.log("当前文件列表", this.fileList);
    },

    // 提交按钮的处理函数
    handleSubmitRules() {
      // 需要提交的数据，包括用户输入的文本和文件
      const formData = new FormData();
      formData.append('submitText', this.submitText);  // 添加用户输入的文本
      if (this.uploadedFile) {
        formData.append('file', this.uploadedFile);   // 添加文件
      }

      // 执行文件提交到后台接口的逻辑
      this.submitToBackend(formData);
    },

    // 提交到后台接口
    submitToBackend(formData) {
      // 发送请求，替换下面的 URL 为实际的后台接口
      this.$axios.post('http://your-backend-api-url.com/submit', formData)
          .then(response => {
            ////console.log('提交成功:', response.data);
          })
          .catch(error => {
            // console.error('提交失败:', error);
          });
    },
    async LoadRoomList() {
      let data = {
        "data_type": "load_room_list"
      }
      ////console.log("发送群聊消息请求")
      this.sendMessage(data)

      ////console.log("发送请求获取群聊数据")
      // let resData = await this.postAxios(url, data)
      // ////console.log("===")
      // ////console.log(resData)
    },
    handleLoadRoomList(resData) {
      ////console.log(resData)
      if (resData) {
        this.allRoomSettings = []
        this.fullRoomList = resData
        ////console.log("加载群聊数: " + this.fullRoomList.length)
        let activeRoomList = []
        let afterRoomList = []
        if (Array.isArray(this.fullRoomList)) {
          this.fullRoomList.forEach(item => {
            if (item["nickname"] !== "") {
              let cacheSettingStr = localStorage.getItem(item["wxid"] + "+taskSettings")
              if (cacheSettingStr) {
                let cacheSettings = JSON.parse(cacheSettingStr)
                cacheSettings["order"] = this.allRoomSettings.length + 1 + ""
                if (!cacheSettings["ruleTask"].hasOwnProperty("closeTimer")) {
                  cacheSettings["ruleTask"]["closeTimer"] = "一直扣"
                }
                // if (cacheSettings["ruleTask"].hasOwnProperty("rules")) {
                //   this.ruleList = cacheSettings["ruleTask"]["rules"]
                // }
                if (!cacheSettings.hasOwnProperty("KeyTask")) {
                  cacheSettings["KeyTask"] = {
                    "title": "关键字回复",
                    "switchValue": false,
                    "keyText": "",
                    "senders": [],
                    "closeTimer": "一直扣",
                    "sendContent": "p",
                    "timeoutTime": 0
                  }
                }
                if (!cacheSettings.hasOwnProperty("AiTask")) {
                  cacheSettings["AiTask"] = {
                    "title": "全自动Ai回复",
                    "switchValue": false,
                    "keyText": "",
                    "senders": [],
                    "closeTimer": "一直扣",
                    "timeoutTime": 0
                  }
                }
                activeRoomList.push(cacheSettings)
              } else {
                afterRoomList.push({
                  "order": this.allRoomSettings.length + 1 + "",
                  "avatar_url": item["avatar"],
                  "roomName": item["nickname"],
                  "roomId": item["wxid"],
                  "isOpen": false,
                  "ruleTask": {
                    "title": "扣排功能设置",
                    "switchValue": false,
                    "rules": [],
                    // "timeoutTime": 0,
                    // "detechMin": "不限",
                    // "keyContent": "",
                    "closeTimer": "一直扣",
                    // "senders": ["不限"],
                    // "deal_names": []
                  },
                  "timerTask": {
                    "title": "定时发送消息",
                    "switchValue": false,
                    "minutesValue": 0,
                    "timeoutTime": 0,
                    "sendContent": ""
                  },
                  "followTask": {
                    "title": "跟排发送设置",
                    "switchValue": false,
                    "startText": "",
                    "closeTimer": "一直扣",
                    "timeoutTime": 0,
                    "sendTimer": 3
                  },
                  "KeyTask": {
                    "title": "关键字回复",
                    "switchValue": false,
                    "keyText": "",
                    "senders": [],
                    "closeTimer": "一直扣",
                    "sendContent": "p",
                    "timeoutTime": 0
                  },
                  "AiTask": {
                    "title": "全自动Ai回复",
                    "switchValue": false,
                    "keyText": "",
                    "senders": [],
                    "closeTimer": "一直扣",
                    "timeoutTime": 0
                  }
                })
              }
            }
          })
        }
        this.allRoomSettings = activeRoomList.concat(afterRoomList)
        ////console.log(this.allRoomSettings)
        // 排序
        for (let i = 0; i < this.allRoomSettings.length; i++) {
          this.allRoomSettings[i]["order"] = i + 1 + ""
        }
        this.showAllRoomSettings = this.allRoomSettings
        this.sortSettingsList()

      } else {
        this.connected = false
      }
    },
    updateGlobalVariable(newData) {
      this.$store.commit('setGlobalVariable', newData);
    },
    async handleActive() {
      // let url = this.baseUrl + "/action"
      let data = {
        "type": "ACTIVE_CODE",
        "data": {
          "code": this.secret,
          "inviteCode": this.inviteCode
        },
        "data_type": "action"
      }
      // let resData = await this.postAxios(url, data)
      this.sendMessage(data)

    },
    handleActiveLocal(resData) {
      ////console.log("resData", resData)
      if (resData) {
        ////console.log("resData", resData)
        this.$store.commit('setExpireTime', resData["data"]["expire_time"]);
        if (this.isAuth) {
          this.$store.commit('setHeaderExpireDialog', !resData["data"]["is_auth"]);
        } else {
          this.$store.commit('setHeaderExpireDialog', this.isAuth);
        }

        // this.$store.commit('setSecret', "");

        if (resData["data"]["is_auth"]) {

          ElMessage.success("激活成功: " + resData["data"]["expire_time"])
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        } else {
          ElMessage.error("激活失败，请使用有效的卡密")
        }

      }
    },
    async getRoomMembers(roomId) {
      // let url = this.baseUrl + "/"
      let data = {
        "data": {
          "room_wxid": roomId
        },
        "data_type": "room_members"
      }
      // let resData = await this.postAxios(url, data)
      this.sendMessage(data)
    },
    handleRoomMembers(resData) {
      ////console.log("收到群聊成员信息:")
      ////console.log(resData)
      if (resData && resData.hasOwnProperty("data")) {
        let members = []
        resData["data"]["member_list"].forEach((item) => {
          members.push({
            "key": item["wxid"],
            "value": item["display_name"] === "" ? item["nickname"] : item["display_name"]
          })
        })
        this.room_members = members
        this.raw_members = members
        this.room_members.unshift({
          "key": "不限",
          "value": "不限"
        })
        ////console.log("room_members", this.room_members)
      }
    },
    async postAxios(url, data) {
      try {
        let res = await axios.post(url, data)
        if (res.status === 200) {
          return res["data"]
        }
      } catch (e) {
        ElMessage.warning("网络异常!")
        this.connected = false
      }
    },
    sendGlobalMessage(title, content, formattedDate) {
      // let formattedDate = new Date().toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.globalMessage.unshift({
        id: this.globalMessage.length + 1,
        title: title,
        time: formattedDate,
        content: content
      })
      this.$store.state.unreadNum = this.$store.state.unreadNum + 1
      // 先检查是否超过了20条消息
      if (this.globalMessage.length >= 20) {
        // 如果超过了20条，删除最后一条消息
        this.globalMessage.splice(-1, 1);
      }
    },
    handleRefresh() {
      window.location.reload()
    },
    async SaveFormData(itemSettings) {
      ////console.log("itemSettings", itemSettings)
      ////console.log("allRoomSettings", this.allRoomSettings)
      this.dialogFormVisible = false
      this.itemSettings = itemSettings
      localStorage.setItem(itemSettings["roomId"] + "+taskSettings", JSON.stringify(this.itemSettings))
      ////console.log("preData", JSON.stringify())
      this.sortSettingsList()
      this.showAllRoomSettings.sort((a, b) => {
        if (a.roomId === itemSettings.roomId) return -1; // 当前项是目标项，排前面
        if (b.roomId === itemSettings.roomId) return 1;  // 目标项在 b 中，排后面
        return 0; // 保持原顺序
      });
      await this.postSettings()
    },
    sortSettingsList() {
      this.showAllRoomSettings.sort((a, b) => {
        if (a.isOpen === b.isOpen) {
          return 0; // 保持原有顺序
        }
        return a.isOpen ? -1 : 1; // isOpen 为 true 的排在前面
      });
    },
    searchChange(newValue) {
      ////console.log(newValue)
      this.showAllRoomSettings = this.allRoomSettings.filter(data => !newValue || data.roomName.toLowerCase().includes(newValue.toLowerCase()))
    },
    async postSettings() {
      // 将配置信息发送过去
      let preData = {}
      preData["active_groups"] = []
      preData["data_type"] = "settings"

      for (let i = 0; i < this.allRoomSettings.length; i++) {
        ////console.log(this.allRoomSettings[i])
        if (this.allRoomSettings[i]["isOpen"]) {
          preData["active_groups"].push(this.allRoomSettings[i]["roomId"])
          preData["current_wxid"] = this.currentLoginWx["wx_id"]
          preData[this.allRoomSettings[i]["roomId"]] = this.allRoomSettings[i]
        }
      }
      ////console.log("发送数据", preData)

      // let url = this.baseUrl + "/settings"
      // let res = await axios.post(url, preData)
      // if(res.status === 200) {
      //   ////console.log("返回数据:", res.data)
      // }
      ////console.log("发送了", preData)
      this.sendMessage(preData)
    },
    sendMessage(data) {
      if (this.socket) {
        this.socket.emit('message', handleEncryptData(data, isDebug));
      } else {
        // console.error('WebSocket not connected!');
      }
    },
    handlePageChange(page) {
      if (!this.isAllData) {
        this.currentData = this.currentAllData.slice((page - 1) * this.pageSize, (page) * this.pageSize)
      } else {
        this.pageCount = page
        this.getTaskOrder()
      }
    },
    handleEdit(index, row) {
      ////console.log(index, row)
      this.rules = []
      this.dialogFormVisible = true
      this.itemSettings = row
      // 获取群成员
      this.getRoomMembers(row.roomId)
    },
    changePage(currentPage) {
      // 在这里处理分页切换逻辑，currentPage 即为当前页码
      ////console.log('当前页码:', currentPage);
      this.currentPage = currentPage
    },
    async handleSwitchChange(row, value) {
      row.isOpen = value;
      localStorage.setItem(row["roomId"] + "+taskSettings", JSON.stringify(row))
      await this.postSettings()
    },
    updateTotal() {
      this.total = this.isAllData.length;
    },
    calculateRemainingSeconds(targetMinute) {
      // 获取当前时间
      const now = new Date();
      let setTime = new Date();

      // 获取当前小时和分钟
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      setTime.setHours(currentHour, targetMinute, 0, 0)
      if (currentMinute >= targetMinute) {
        setTime = new Date(setTime.getTime() + 3600 * 1000)
      } else {
        setTime.setHours(currentHour, targetMinute, 0, 0)
      }
      return setTime.getTime() - now.getTime()
    }
  },
  // 4. 在 computed 中定义计算属性
  computed: {
    // 使用全局变量
    globalVariable() {
      return this.$store.state.globalVariable;
    },
    currentInfo() {
      return this.$store.state.currentInfo;
    },
    // 修改 filterTableData 以根据分页信息截取数据
    filterTableData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.showAllRoomSettings.slice(startIndex, endIndex);
    },
    pageCount() {
      return parseInt(this.allRoomSettings.length / this.pageSize) + 1
    },
    globalMessage() {
      return this.$store.state.globalMessage;
    },
    unreadNum() {
      return this.$store.state.unreadNum;
    },
    selfRules() {
      return this.$store.state.selfRules;
    },
    currentPageData() {
      // 用于渲染当前页的数据
      return this.filterTableData;
    },
  },
}
</script>


<style lang="scss" scoped>
.tooltip-wrapper {
  position: relative; /* 设置 wrapper 为 relative */
}

.help-button {
  position: absolute;
  top: 0; /* 上边距为 0，定位到容器的上边 */
  right: 0; /* 右边距为 0，定位到容器的右边 */
  //background-color: #3f8bfa; /* 按钮背景色（可修改） */
  color: white; /* 按钮文字颜色（可修改） */
  padding: 5px 10px; /* 按钮的内边距 */
  cursor: pointer; /* 鼠标悬停时显示为指针 */
  font-size: 20px;
}

.gif-container {
  position: fixed; /* 使用 fixed 定位，使其相对于浏览器窗口固定 */
  top: 50%; /* 设置垂直居中 */
  right: 10px; /* 距离右侧 10px */
  z-index: 1000; /* 确保它显示在其他元素之上 */
  transform: translateY(-50%); /* 完全居中显示 */
}

.gif-image {
  max-width: 300px; /* 设置 GIF 图片的最大宽度 */
  max-height: 300px; /* 设置 GIF 图片的最大高度 */
  object-fit: contain; /* 保持图片的宽高比例 */
}

.center-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.centered-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60%; /* 使容器占据整个视口的高度 */
}

.instruction-text {
  color: white;
  font-size: 20px;
  margin: 10px 0; /* 设置上下间隙，根据需要调整数值 */
}

/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}

/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
  background-color: transparent !important;
  border: 0; //去除表格
}

::v-deep .el-pagination {
  background-color: transparent !important;
  border: 0; //去除表格
}

/*去除底边框*/
::v-deep.el-table td.el-table__cell {
  border: 0;
}

::v-deep.el-table th.el-table__cell.is-leaf {
  border: 0;
}

/*去除底部灰条.el-table::before*/
::v-deep .el-table::before {
  display: none;
  height: 0;
}

::v-deep .el-table__inner-wrapper::before {
  height: 0;
}

.dynamic-width-input {
  width: 300px; /* 设置默认较短的宽度 */
  min-width: 100px; /* 设置最小宽度 */
  max-width: 500px; /* 设置最大宽度 */
}


// 分页样式改造
::v-deep .el-pagination.is-background .btn-prev {
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}

::v-deep .el-pagination.is-background .btn-next {
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}

::v-deep .el-pagination.is-background .el-pager li {
  background: transparent;
  border-radius: 2px;
  //border: 1px solid #295a85;
  color: #fff;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #cc66ff;
}

::v-deep .el-pagination__editor.el-input .el-input__inner {
  background: transparent;
  //border: 1px solid #295a85;
  color: #fff;
}

::v-deep .el-pagination__total, ::v-deep .el-pagination__jump {
  color: #fff;
}

.dialog-content {
  background: -webkit-linear-gradient(left, rgb(145, 217, 246) 0%, #db6ff3 100%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0;
}

.fade-enter-to, .fade-leave {
  opacity: 1;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.icon-container-left {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
}

.custom-btn {
  width: 130px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  padding: 10px 10px;
  //margin: 0 10px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5), 7px 7px 20px 0px rgba(0, 0, 0, .1),
  4px 4px 5px 0px rgba(0, 0, 0, .1);
  outline: none;

}

.btn-9 {
  border: none;
  transition: all 0.3s ease;
  overflow: hidden;

  &:after {
    position: absolute;
    content: " ";
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1fd1f9;
    background-image: linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%);
    transition: all 0.3s ease;
  }

  &:hover {
    background: transparent;
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .5),
    -4px -4px 6px 0 rgba(116, 125, 136, .2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, .5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
    color: #fff;
  }

  &:hover:after {
    -webkit-transform: scale(2) rotate(180deg);
    transform: scale(2) rotate(180deg);
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, .5),
    -4px -4px 6px 0 rgba(116, 125, 136, .2),
    inset -4px -4px 6px 0 rgba(255, 255, 255, .5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
  }
}

.btn-12 {
  position: relative;
  right: 20px;
  bottom: 20px;
  border: none;
  box-shadow: none;
  width: 130px;
  height: 40px;
  line-height: 42px;
  -webkit-perspective: 230px;
  perspective: 230px;

  & span {
    background: rgb(0, 172, 238);
    background: linear-gradient(0deg, rgba(0, 172, 238, 1) 0%, rgba(2, 126, 251, 1) 100%);
    display: block;
    position: absolute;
    width: 130px;
    height: 40px;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
    7px 7px 20px 0px rgba(0, 0, 0, .1),
    4px 4px 5px 0px rgba(0, 0, 0, .1);
    border-radius: 5px;
    margin: 0;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all .3s;
    transition: all .3s;
  }

  & span:nth-child(1) {
    box-shadow: -7px -7px 20px 0px #fff9,
    -4px -4px 5px 0px #fff9,
    7px 7px 20px 0px #0002,
    4px 4px 5px 0px #0001;
    -webkit-transform: rotateX(90deg);
    -moz-transform: rotateX(90deg);
    transform: rotateX(90deg);
    -webkit-transform-origin: 50% 50% -20px;
    -moz-transform-origin: 50% 50% -20px;
    transform-origin: 50% 50% -20px;
  }

  & span:nth-child(2) {
    -webkit-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
    -webkit-transform-origin: 50% 50% -20px;
    -moz-transform-origin: 50% 50% -20px;
    transform-origin: 50% 50% -20px;
  }

  &:hover span:nth-child(1) {
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
    7px 7px 20px 0px rgba(0, 0, 0, .1),
    4px 4px 5px 0px rgba(0, 0, 0, .1);
    -webkit-transform: rotateX(0deg);
    -moz-transform: rotateX(0deg);
    transform: rotateX(0deg);
  }

  &:hover span:nth-child(2) {
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
    7px 7px 20px 0px rgba(0, 0, 0, .1),
    4px 4px 5px 0px rgba(0, 0, 0, .1);
    color: transparent;
    -webkit-transform: rotateX(-90deg);
    -moz-transform: rotateX(-90deg);
    transform: rotateX(-90deg);
  }
}

</style>

